import { useUser } from "auth";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

const Impersonate = () => {
  const [, setToken] = useUser();
  const history = useHistory();
  const location = useLocation();
  // The token comes in the URL fragment, which browsers never send to a
  // server, so it stays out of access logs (SEC-07). ?token= still works for
  // links made by an older partners portal.
  const token =
    new URLSearchParams(location.hash.replace(/^#/, "")).get("token") ??
    new URLSearchParams(location.search).get("token");

  useEffect(() => {
    setToken(token);
    // replace, so the token isn't left in the back-button history.
    history.replace("/");
  }, [token, history, setToken]);

  return null;
};

export default Impersonate;
